import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { CheckCircle2, ShieldCheck, Loader2, X } from "lucide-react";

// Lands here from the parent-consent email. Automatically POSTs the token.

export default function ParentConsentPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [state, setState] = useState({ status: "loading", childName: "", error: "" });

  useEffect(() => {
    if (!token) { setState({ status: "error", childName: "", error: "Missing consent token." }); return; }
    let cancelled = false;
    api.post("/auth/parent-consent", { token })
      .then(({ data }) => { if (!cancelled) setState({ status: "ok", childName: data.child_name || "the reader", error: "" }); })
      .catch((e) => { if (!cancelled) setState({ status: "error", childName: "", error: formatApiError(e) }); });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="max-w-xl mx-auto px-6 md:px-12 py-24 fade-up" data-testid="parent-consent-page">
      <div className="font-mono uppercase tracking-[0.25em] text-xs text-[#525252] mb-4 inline-flex items-center gap-2">
        <ShieldCheck className="w-3.5 h-3.5" strokeWidth={1.5} /> Parental consent
      </div>
      {state.status === "loading" && (
        <div className="border border-dashed border-[rgba(0,0,0,0.12)] p-16 text-center">
          <Loader2 className="w-6 h-6 animate-spin mx-auto mb-4 text-[#525252]" strokeWidth={1.5} />
          <div className="font-heading text-2xl text-[#525252]">Confirming permission…</div>
        </div>
      )}
      {state.status === "ok" && (
        <div className="border border-[rgba(0,0,0,0.10)] bg-[#FAF5E6] p-10 text-center">
          <CheckCircle2 className="w-8 h-8 mx-auto mb-4 text-[#0A0A0A]" strokeWidth={1.5} />
          <h1 className="font-heading text-3xl text-[#0A0A0A] tracking-tight">Thank you.</h1>
          <p className="text-[#4A4030] mt-3 leading-relaxed">
            <strong>{state.childName}</strong>'s Reads account is now active. They can sign in and start their reading journal whenever they're ready.
          </p>
          <p className="text-sm text-[#525252] mt-6">Questions later? Reply to the email we sent you and a human will respond.</p>
        </div>
      )}
      {state.status === "error" && (
        <div className="border border-[#B91C1C]/20 bg-[#B91C1C]/5 p-10 text-center">
          <X className="w-8 h-8 mx-auto mb-4 text-[#B91C1C]" strokeWidth={1.5} />
          <h1 className="font-heading text-3xl text-[#B91C1C] tracking-tight">Couldn't confirm</h1>
          <p className="text-[#4A4030] mt-3 leading-relaxed">{state.error}</p>
          <Link to="/" className="font-mono uppercase tracking-widest text-xs text-[#0A0A0A] hover:underline mt-6 inline-block">Back to Reads →</Link>
        </div>
      )}
    </div>
  );
}
